import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Radio as MuiRadio } from "@mui/material";
import { RaiseColors, makeStyles } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var SIZE_MAP = {
  small: {
    outer: "18px",
    inner: "9px"
  },
  medium: {
    outer: "24px",
    inner: "12px"
  }
};
var useStyles = makeStyles(function (theme) {
  return {
    checkedIcon: function checkedIcon(props) {
      return {
        width: props.outer,
        height: props.outer,
        backgroundColor: props.disabled ? RaiseColors.jllNeutral400 : RaiseColors.bahama1200,
        border: "1px solid ".concat(props.disabled ? RaiseColors.jllNeutral400 : RaiseColors.bahama1200),
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        "&:before": {
          content: '""',
          width: props.inner,
          height: props.inner,
          backgroundColor: props.disabled ? RaiseColors.neutral200 : RaiseColors.white,
          borderRadius: "50%",
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)"
        }
      };
    },
    icon: function icon(props) {
      return {
        width: props.outer,
        height: props.outer,
        backgroundColor: RaiseColors.white,
        border: "1px solid ".concat(props.disabled ? RaiseColors.jllNeutral400 : RaiseColors.glacier400),
        borderRadius: "50%",
        display: "inline-block"
      };
    }
  };
});
var Radio = function Radio(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    muiRadioProps = _objectWithoutProperties(_ref, _excluded);
  var dimensions = SIZE_MAP[size === "small" ? "small" : "medium"];
  var outer = dimensions.outer,
    inner = dimensions.inner;
  var classes = useStyles({
    outer: outer,
    inner: inner,
    disabled: muiRadioProps.disabled
  });
  return /*#__PURE__*/_jsx(MuiRadio, _objectSpread({
    "data-testid": "radio-test",
    size: size,
    checkedIcon: /*#__PURE__*/_jsx("span", {
      className: classes.checkedIcon
    }),
    icon: /*#__PURE__*/_jsx("span", {
      className: classes.icon
    }),
    disableRipple: true
  }, muiRadioProps));
};
export default Radio;